
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import ruleMixin from '@/minix/ruleMixin';
import api from '@/api';
import Swal from 'sweetalert2';
import DateRange from '@/components/DateRange.vue';
import moment from 'moment';

const { shoppingGiveBackMerchant } = api;
const { requiredRule, maxLengthRule } = { ...ruleMixin.methods };

@Component({
  components: {
    DateRange,
  },
  mixins: [ruleMixin],
})
export default class ShoppingGiveBackMerchantForm extends Vue {
  @Prop({}) private id!: string;

  private loading = false;

  private valid = true;

  private form = {
    name: '',
    memo: '',
    startOn: '',
    endOn: '',
    isEnabled: true,
  };

  private rules = {
    merchantName: [
      ...requiredRule('廠商名稱'),
      ...maxLengthRule('廠商名稱', 10),
    ],
  };

  private async save() {
    if ((this.$refs.form as any).validate()) {
      this.loading = true;
      const { status } = this.isEdit
        ? await shoppingGiveBackMerchant.edit(this.id, this.form)
        : await shoppingGiveBackMerchant.add(this.form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        await this.$router.back();
      }
    }
  }

  private async close() {
    await this.$router.back();
  }

  private get isEdit() {
    return !!this.id;
  }

  private get title() {
    return this.isEdit ? '編輯' : '新增';
  }

  private async setForm(form: any) {
    const startOn = moment(form.startOn).format('YYYY-MM-DD');
    const endOn = moment(form.endOn).format('YYYY-MM-DD');
    this.form = { ...form, startOn, endOn };
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: ShoppingGiveBackMerchantForm) => void) | boolean) => void,
  ) {
    if (to.name === 'shoppingGiveBackMerchantEdit') {
      const { data } = await shoppingGiveBackMerchant.get(to.params.id);
      await next(async (vm) => {
        vm.setForm(data);
      });
    } else {
      await next(true);
    }
  }
}
